import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gb_sylt_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('gb_sylt_admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Public API
export const getPublicTiles = async () => {
  const response = await api.get('/tiles');
  return response.data;
};

// Admin API
export const adminLogin = async (username, password) => {
  const response = await api.post('/admin/login', { username, password });
  return response.data;
};

export const getAdminTiles = async () => {
  const response = await api.get('/admin/tiles');
  return response.data;
};

export const createTile = async (tileData) => {
  const response = await api.post('/admin/tiles', tileData);
  return response.data;
};

export const updateTile = async (tileId, tileData) => {
  const response = await api.put(`/admin/tiles/${tileId}`, tileData);
  return response.data;
};

export const deactivateTile = async (tileId) => {
  const response = await api.delete(`/admin/tiles/${tileId}`);
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/admin/me');
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.put('/admin/change-password', {
    current_password: currentPassword,
    new_password: newPassword
  });
  return response.data;
};

export default api;
